import { frontendURL } from 'dashboard/helper/URLHelper.js';

const CandidatesIndex = () =>
  import('dashboard/routes/dashboard/candidates/Index.vue');

const candidatesRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/candidates'),
      name: 'candidates_index',
      meta: {
        // Administradores e agentes (§2 do design): quem opera o funil de
        // recrutamento é o RH, que não é admin da conta.
        permissions: ['administrator', 'agent'],
      },
      component: CandidatesIndex,
    },
  ],
};

export default candidatesRoutes;
